import React from "react";
import { compose, withAppContext } from "containers/HOC";
import { usePortalModal } from "common/effects";
import PaymentModal from "containers/Payments/PaymentModal";
import ActionLink from "components/ActionLink";
import { useCanExtendSubscription } from "containers/Payments/_queries";

const ExtendSubscriptionLink = ({ farm, onPaid, online, refData }) => {
    const { openModal, getModal } = usePortalModal();
    const canExtendSubscription = useCanExtendSubscription();

    const pay = (farm) => (e) => {
        openModal("PaymentModal", { farms: [farm], onPaid });
    };

    const paymentModal = getModal("PaymentModal", PaymentModal);

    const canExtend = canExtendSubscription(farm) && refData.deploymentType === "Commercial" && online;

    return canExtend ? (
        <>
            <ActionLink id="farm-home-make-payment" className="IconLink--dollar ExtendSubscription" onClick={pay(farm)}>
                Extend subscription
            </ActionLink>
            {paymentModal}
        </>
    ) : null;
};

export default compose(withAppContext)(ExtendSubscriptionLink);
